import $ from 'jquery';
import { dependency } from '../utils/request'

export default function registerPage() {
    const $html = $('html');
    const $scroller = $('html, body');
    const $page = $('.register-page');

    if ($page.length) {
        const $inputs = $page.find('input.float-label_field');
        const registrationType = $page.attr('data-type');
        const registrationPrice = parseInt($page.attr('data-price'));
        const checkUrl = $page.attr('data-check-url');
        const checkCodeUrl = $page.attr('data-check-code-url');
        const userUrl = $page.attr('data-user-url');
        const redirectUrl = $page.attr('data-redirect-url');
        const $errors = $page.find('.error');

        const $emailInput = $('input[name="email_address"]');
        const $nameInput = $('input[name="first_name"]');
        const $passwordInput = $('input[name="password"]');
        const $surnameInput = $('input[name="last_name"]');
        const $accessCodeInput = $inputs.filter('[name="access_code"]');
        const $csrf = $('[name="CSRF_TOKEN"]');

        const checkInputsValidity = () => {
            let isValid = true;

            if ($inputs.parent().hasClass('is-invalid')) {
                isValid = false;
                $inputs.each(function () {
                    const $this = $(this);

                    if ($this.val() === '') {
                        $this.parent().parent().find('.error.-empty').show();
                    } else if ($this.parent().hasClass('is-invalid')) {
                        $this.parent().parent().find('.error.-invalid').show();
                    }
                });
            }

            return isValid;
        }

        const completeIt = (paypalCode) => {
            $.post({
                url: userUrl,
                data: {
                    email: $emailInput.val(),
                    password: $passwordInput.val(),
                    first: $nameInput.val(),
                    last: $surnameInput.val(),
                    code: paypalCode,
                    type: registrationType,
                    CSRF_TOKEN: $csrf.val()
                }
            }).done(function (data) {
                const decoded = JSON.parse(data);

                if (decoded.success) {
                    const host = window.location.origin + '/';
                    const params = {
                        created: true,
                    };
                    if (typeof redirectUrl !== 'undefined' && redirectUrl !== null) {
                        params.redirect = redirectUrl;
                    }
                    const queryString = new URLSearchParams(params).toString();
                    window.location.href = `${host}login?${queryString}`;
                } else {
                    $('.whole-error').removeClass('+hidden');
                }
            });
        }

        paypal.Buttons({
            createOrder: function (data, actions) {
                return actions.order.create({
                    payer: {
                        name: {
                            given_name: $nameInput.val(),
                            surname: $surnameInput.val()
                        },
                        email_address: $emailInput.val()
                    },
                    purchase_units: [{
                        amount: {
                            value: registrationPrice,
                        }
                    }]
                });
            },
            onApprove: function (data, actions) {
                // This function captures the funds from the transaction.
                return actions.order.capture().then(function (details) {
                    // This function shows a transaction success message to your buyer.
                    // alert('Transaction completed by ' + details.payer.name.given_name);
                    // 'email=' + $emailInput.val() + '&first=' + $nameInput.val() + '&last=' + $surnameInput.val()

                    completeIt(JSON.stringify(details));
                });
            },
            onInit: function (data, actions) {
                actions.disable();

                $inputs.on('keyup', function () {
                    $errors.hide();
                    if ($inputs.parent().hasClass('is-invalid')) {
                        actions.disable();
                    } else {
                        actions.enable();
                    }
                });

                $inputs.on('focusout', function () {
                    const $this = $(this);

                    if ($this.attr('type') === 'email' && $this.val() !== '' && !$this.parent().hasClass('is-invalid')) {

                        $.post({
                            url: checkUrl,
                            data: {
                                email: $emailInput.val(),
                                CSRF_TOKEN: $csrf.val()
                            }
                        }).done(function (data) {
                            const decoded = JSON.parse(data);
                            if (decoded.hasUser) {
                                $('.error.-has-email').show();
                                $this.focus();
                                actions.disable();
                            } else {
                                actions.enable();
                            }
                        });
                    }
                });

                $page.find('[data-code-submit]').on('click', function(event) {
                    event.preventDefault();
                    $.post({
                        url: checkCodeUrl,
                        data: {
                            code: $accessCodeInput.val(),
                            type: registrationType,
                            CSRF_TOKEN: $csrf.val(),
                        }
                    }).done(function (data) {
                        if (data.success) {
                            // checkInputsValidity() will show any relevant error messages
                            if (checkInputsValidity()) {
                                completeIt(null);
                            }
                        } else {
                            $accessCodeInput.parent().siblings('.error.-invalid').show();
                        }
                    });
                });
            },
            onClick: function (data, actions) {
                checkInputsValidity();
            },
            onError: function (err) {
                alert('An issue has occurred. ' + err);
            }
        }).render('#paypal-button-container');

    }
}



// WEBPACK FOOTER //
// ./source/scripts/pages/register.js